import { defineStore } from 'pinia';
import { CacheExpiryForStoreInHours } from '../../appConstants';
import { IConfiguration } from '../../interfaces/IConfiguration';
import { hasStoreContentExpired } from '../../helpers';

export const useConfigStore = defineStore('configStore', {
  state: (): IConfiguration => ({
    SearchResultsUrl: '',
    CarDetailsUrl: '',
    CarComparisonUrl: '',
    BasePath: '',
    ComponentName: '',
    HomePageUrl: '',
    ExpertReviewsUrl: '',
    LastUpdated: '',
    NumberOfHoursForStoreContentToExpire: CacheExpiryForStoreInHours,
  }),
  actions: {
    setConfigState(configObj: IConfiguration) {
      this.$patch((state) => {
        state.BasePath = configObj.BasePath;
        state.ComponentName = configObj.ComponentName;
        state.SearchResultsUrl = configObj.SearchResultsUrl;
        state.CarDetailsUrl = configObj.CarDetailsUrl;
        state.CarComparisonUrl = configObj.CarComparisonUrl;
        state.HomePageUrl = configObj.HomePageUrl;
        state.ExpertReviewsUrl = configObj.ExpertReviewsUrl;
        state.LastUpdated = configObj.LastUpdated;
        state.NumberOfHoursForStoreContentToExpire = configObj.NumberOfHoursForStoreContentToExpire;
      });
    },
  },
  getters: {},
  persist: true,
});
